export enum TelephoneOperatorStatus {
    CLARO = '1001',
    MOVISTAR = '1002',
    CNT = '1003',
    TUENTI = '1004'
  }